export const AlbertaCaDomain = `https://www.alberta.ca`; //this may need to be moved to config.json, but for now just putting it in a const.
export const VerifyAccountUrl = `${AlbertaCaDomain}/alberta-ca-account-for-personal-use#jumplinks-2`;
